import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import LatestVideos from "@/pages/home/components/LatestVideos";
import TrendingRanking from "@/pages/home/components/TrendingRanking";

export default function Home() {
  return (
    <div>
      <HeroCarousel />

      <div className="w-full px-4 md:px-8 py-10 md:py-14 space-y-12 md:space-y-16">
        <CategoryShortcuts />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <LatestVideos />
          </div>
          <aside className="lg:col-span-1">
            <TrendingRanking />
          </aside>
        </div>

        <section className="rounded-lg bg-accent-100 border border-accent-200 px-6 py-8 md:px-10 md:py-10">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div className="max-w-2xl">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                关于樱桃视频
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                樱桃视频汇聚短视频、网络电影与娱乐综艺，为你提供便捷的内容发现与浏览体验。
                无论是碎片时间的小惊喜，还是整块时间的沉浸观看，都能在这里找到喜欢的内容。
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-3 shrink-0">
              <Link
                to="/about"
                className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-label font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                了解我们
              </Link>
              <Link
                to="/about"
                className="rounded-md border border-secondary-300 bg-background-50 px-5 py-2.5 text-sm font-label text-secondary-900 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                合作与联系
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}